import styled from "styled-components"

export const ChangePasswordWrapper = styled.div`
    border-radius: 4px;
    form{
        width: 600px;
    }
`
